module.exports = __webpack_public_path__ + "img/DE00757.d2c7d600.png";